import React, { useEffect, useState } from "react";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import FailureWebLogo from "../../assets/svg/web-failure-otp.svg";
import FailureMobLogo from "../../assets/svg/mob-failure-otp.svg";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPaymentStatus,
  handleInitiatePayment,
} from "../../store/reducers/prosure/apiThunk";
import {
  resetDetail,
  updateFailed,
  updatePayment,
  updateSuccess,
  updateTransactionTimer,
} from "../../store/reducers/prosure";
import { AppDispatch } from "../../store/store";
import { showToast } from "../../components/Toast";
import { updateLoading } from "../../store/reducers/loader";
import { resetPrice } from "../../store/reducers/home";
import { trackEvent } from "../../analytics";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector((state: any) => state);
  const {
    prosure: {
      formDetail,
      otpVerified,
      otpDone,
      prosureUserId,
      paymentData,
      failedUpdate,
    },
    home: { totalPrice },
  } = userData;
  const [successData, setSuccessData] = useState({});
  useEffect(() => {
    if (Number(totalPrice) === 0) {
      navigate(ROUTE_PATH.HOME);
    } else if (Object.keys(formDetail)?.length === 0) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    } else if (otpVerified === false) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    }
  }, []);

  useEffect(() => {
    statusAPI();
  }, []);

  const statusAPI = async () => {
    if (!failedUpdate) {
      try {
        const res = await dispatch(
          fetchPaymentStatus(paymentData?.transactionId)
        ).unwrap(); // Unwraps to return raw result or throw error
        if (res?.status === 1) {
          dispatch(updateFailed(true));
          dispatch(updateTransactionTimer(20000));
          setSuccessData(res?.data);
        }
      } catch (error) {
        dispatch(updateFailed(false));
        dispatch(updateTransactionTimer(20000));
        showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
    } else {
      dispatch(updateTransactionTimer(20000));
    }
  };

  const paymentInitiatedFun = async () => {
    const data = {
      firstName: formDetail?.firstName,
      lastName: formDetail?.lastName,
      productInfo: "ProSure",
      amount: totalPrice,
      email: formDetail?.email,
      phone: formDetail?.mobileNo,
      surl: window.location.origin + ROUTE_PATH.SUCCESS_PAYMENT,
      furl: window.location.origin + ROUTE_PATH.FAILURE_PAYMENT,
      prosureCustomerId: prosureUserId,
    };
    try {
      const res = await dispatch(handleInitiatePayment(data)).unwrap(); // Unwraps to return raw result or throw error
      if (res?.status === 1) {
        dispatch(updatePayment(res?.data));
        dispatch(updateFailed(false));
        dispatch(updateSuccess(false));
        dispatch(updateTransactionTimer(20000));
        const params = {
          page_location: window.location.href,
          button_text: "Proceed to Pay",
        }; // Current page URL

        trackEvent("begin_checkout", params);
        setTimeout(() => {
          navigate(ROUTE_PATH.PAYMENT);
        }, 3000);
      }
    } catch (error) {
      dispatch(updateFailed(false));
      dispatch(updateTransactionTimer(20000));
      dispatch(updateSuccess(false));
      showToast("Something went wrong", "error");
    }
  };

  return (
    <div className="flex items-center justify-center w-[100%] h-[100vh] bg-bg-color-3 sm:bg-bg-color-5 relative">
      <div className="bg-bg-color-3 py-[14px] px-[16px] sm:py-[60px] sm:px-[88px] sm:rounded-[30px] bg-bg-color-3 sm:shadow-custom-light sm:w-[70%] lg:w-[60%]  xl:w-[45%]">
        <div className="flex flex-col items-center justify-center sm:mb-[36px] mb-[24px]">
          <img
            src={CoversureLogo}
            alt="CoversureLogo"
            className="hidden sm:block h-[22px]"
          />
          <img
            src={FailureWebLogo}
            alt="FailureWebLogo"
            className="hidden sm:block h-[110px] mt-[72px] mb-[22px]"
          />
          <img
            src={FailureMobLogo}
            alt="FailureMobLogo"
            className="block sm:hidden h-[60px] mb-[11px]"
          />
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] font-bold text-text-color-6 ">
            Oops!
          </div>
          <div className="sm:text-[30px] text-[16px] sm:leading-[38px] leading-[20px] font-bold text-text-color-6 ">
            Payment failed.
          </div>

          <div
            onClick={() => {
              paymentInitiatedFun();
            }}
            className="sm:text-[18px] text-[12px] sm:leading-[38px] leading-[15px] font-bold text-text-color-2 mt-[10px] underline cursor-pointer"
          >
            Try again
          </div>
        </div>
      </div>
      <div
        className="absolute bottom-0 bg-text-color-6 text-bg-color-5 w-[100%] p-[10px] text-center text-[12px] leading-[18px] font-semibold cursor-pointer block sm:hidden"
        onClick={() => {
          dispatch(resetDetail({}));
          dispatch(resetPrice(0));
          dispatch(updateLoading(false));
          navigate(ROUTE_PATH.HOME);
        }}
      >
        Restart client journey
      </div>
    </div>
  );
};

export default PaymentFailure;
